<div class="aag" *ngIf="showAag" [ngClass]="{'media-engine': mediaEngineData}">
    <div class="media" finderAriaHidden="safari" *ngIf="!aagData.styleOverrides?.hideHeroMedia">
        <finder-hero-media *ngIf="!mediaEngineData"
            [picture]="aagData.media"
            class="picture fit"></finder-hero-media>
        <finder-media-gallery *ngIf="mediaEngineData"
            [version]="mediaEngine.version"
            [theme]="mediaEngine.theme"
            [production]="mediaEngine.production"
            [config]="mediaEngine.config"
            (mediaEngineIsReady)="mediaEngineIsReady($event)"
            class=theme-{{mediaEngine.theme}}>
        </finder-media-gallery>
    </div>
    <div class="details" [style.background]="gradientState" [class.hide-hero-media]="aagData.styleOverrides?.hideHeroMedia">
        <div [@detailState]="detailStateName"
            (@detailState.done)="detailStateDone($event)">
            <div class="entity-details">
                <finder-title class="title"
                    [icon]="aagData.styleOverrides?.headingIcon"
                    [over-title]="aagData.sponsorName"
                    [title]="aagData.title">
                </finder-title>
                <finder-operating-status
                    class="detail"
                    [data]="aagData"
                    [facilityId]="entityId"
                    [labels]="aagData.labels"
                ></finder-operating-status>
                <finder-breadcrumb class="breadcrumb"
                    [links]="breadcrumb"
                    breadcrumb="{{breadcrumbTemplate}}">
                </finder-breadcrumb>
                <div class="description dynamic-html"
                    [innerHtml]="aagData.description | safeHtml">
                </div>
                <div class="guide-map" *ngIf="aagData.guideMap">
                    <finder-font-icon size="xs" [htmlEntity]="'&#58116;'"></finder-font-icon>
                    <finder-anchor
                        [href]="aagData.guideMap.href">
                        {{aagData.guideMap.text}}
                    </finder-anchor>
                </div>
                <finder-anchor
                    class="guest-services-link"
                    *ngIf="aagData.guestServicesLink"
                    [href]="aagData.guestServicesLink.href">
                    {{aagData.guestServicesLink.text}}
                </finder-anchor>
                <div class="menu-facets-container">
                    @if (aagData.menuLink) {
                        <div class="menu-link" role="list">
                            <finder-aag-list-item icon="menu">
                                <finder-anchor [href]="aagData.menuLink.href">{{aagData.menuLink.text}}</finder-anchor>
                            </finder-aag-list-item>
                        </div>
                    }
                    <finder-aag-facet class="facets"
                        [facetGroups]="aagData.facetGroups"
                        [entityTypeUrl]="entityTypeUrl">
                    </finder-aag-facet>
                </div>
                <finder-aag-starting-from-price
                    *ngIf="aagData.startingPrice"
                    [startingPrice]="aagData.startingPrice">
                </finder-aag-starting-from-price>
                <finder-aag-duration *ngIf="aagData.duration" class="duration"
                    [icon]="aagData.duration.icon"
                    [label]="aagData.duration.label"
                    [alt]="aagData.duration.alt"
                    [time]="aagData.duration.time">
                </finder-aag-duration>
                <div class="modal discounts" *ngIf="showDiscountsModal">
                    <finder-font-icon class="facet-icon" name="dining-plan-accepted" size="s"></finder-font-icon>
                    <finder-button anchor="true" (click)="openDiscountsModal()"
                        [ariaLabel]="discountsModalLabels.ariaLabel">
                        {{discountsModalLabels.linkText}}
                    </finder-button>
                </div>
                <div class="no-dining-plans-accepted" role="list" *ngIf="aagData.noDiningPlansAccepted">
                    <finder-aag-list-item icon="dining-plan-not-accepted">
                        {{aagData.noDiningPlansAccepted}}
                    </finder-aag-list-item>
                </div>
                <div class="qsr-dining-plans-accepted" role="list" *ngIf="aagData.qsrDiningPlan">
                    <finder-aag-list-item icon="dining-plan-accepted">
                        {{aagData.qsrDiningPlan}}
                    </finder-aag-list-item>
                </div>
                <div class="modal" *ngIf="aagData.accessibilityModal">
                    <finder-font-icon class="facet-icon" name="alert" size="s"></finder-font-icon>
                    <finder-button (click)="openAccesibilityModal()"
                        anchor="true"
                        [ariaLabel]="aagData.accessibilityModal.ariaLabel">
                        {{aagData.accessibilityModal.ctaTitle}}
                    </finder-button>
                </div>
                <div class="modal" *ngIf="aagData.virtualQueue">
                    <finder-font-icon class="facet-icon" name="alert" size="s"></finder-font-icon>
                    <finder-button (click)="openVirtualQueueModal()"
                        anchor="true"
                        [ariaLabel]="aagData.virtualQueue.ariaLabel">
                        {{aagData.virtualQueue.linkText}}
                    </finder-button>
                </div>
            </div>
            <div class="schedule" *ngIf="aagData.schedule">
                <hr aria-hidden="true" class="rule"/>
                @defer {
                    <finder-date-picker-wrapper
                        [labels]="calendarLabels"
                        [(date)]="scheduleService.date"
                        [highlightedDates]="resortReservationDates"
                        [maxDays]="maxDays"
                        (dateChanged)="onDateChanged($event)"
                        (datePickerOpen)="onCalendarOpen($event)"
                        (datePickerClose)="onCalendarClose($event)">
                        <finder-button
                            tabIndex="-1"
                            [id]="'calendar'"
                            anchor="true"
                            class="date-text"
                            title="{{calendarAction}}"
                            ariaLabel="{{scheduleService.fullFormatDate}}. {{calendarLabels.calendarAction.jump}}">
                            {{scheduleService.fullFormatDate}}
                        </finder-button>
                    </finder-date-picker-wrapper>
                }
                <div class="schedule-details">
                    <finder-loading-spinner [hidden]="!scheduleService.isLoading"></finder-loading-spinner>
                    <finder-schedule
                        [hidden]="scheduleService.isLoading || !scheduleService.schedule"
                        [maxDays]="maxDays"
                        [scheduleDate]="scheduleService.date"
                        [schedule]="scheduleService.schedule"
                        [dashStatus]="aagData.operatingStatus">
                    </finder-schedule>
                </div>
            </div>
            <div class="special-event-schedule" *ngIf="aagData.specialEventSchedule">
                <div class="title">{{aagData.specialEventSchedule.title}}</div>
                <div class="date">{{aagData.specialEventSchedule.start}} - {{aagData.specialEventSchedule.end}}</div>
            </div>

            <span class="call-for-reservations" *ngIf="aagData.callForReservations">
                <finder-button
                    *ngIf="aagData.callForReservations.numbers && aagData.callForReservations.numbers.length > 0"
                    href="tel:{{aagData.callForReservations.numbers[0]}}"
                    class="action-btn"
                    theme="primary">
                    {{aagData.callForReservations.title}}
                    <span class="reservation-text-number">: {{aagData.callForReservations.textNumber}}</span>
                </finder-button>
            </span>
            <span class="email-us" *ngIf="aagData.emailForReservations">
                <finder-button
                    href="{{aagData.emailForReservations.mailtoValue}}"
                    class="action-btn"
                    theme="primary">
                    {{aagData.emailForReservations.title}}
                </finder-button>
            </span>
            <finder-button
                *ngIf="aagData.externalCta"
                href="{{aagData.externalCta.href}}"
                class="action-btn"
                externalLink="true"
                theme="primary">
                {{aagData.externalCta.title}}
            </finder-button>
            <finder-button
                href="{{aagData.reserveCta.href}}"
                class="action-btn"
                theme="primary"
                [icon]="aagData.reserveCta.icon"
                *ngIf="aagData.reserveCta && aagData.reserveCta.href; else modal">
                {{aagData.reserveCta.title}}
            </finder-button>
            <ng-template #modal>
                <finder-button
                    (click)="checkAvailabilityAction()"
                    class="action-btn"
                    theme="primary"
                    *ngIf="aagData.reserveCta">
                    {{aagData.reserveCta.title}}
                </finder-button>
            </ng-template>
            <p class="detail-text" *ngIf="aagData.disclaimer">
                {{disclaimerText || aagData.disclaimer.defaultTitle}}
            </p>
            <p class="detail-text" *ngIf="aagData.admissionRequired">
                {{aagData.admissionRequired.title}}
            </p>
            <finder-button
                href="{{aagData.actionButtonUrl}}"
                class="action-btn"
                theme="primary"
                *ngIf="actionButtonText && !addToMyPlans">
                    {{actionButtonText}}
            </finder-button>
            <finder-button
                (click)="addToMyPlansAction()"
                class="action-btn"
                theme="primary"
                *ngIf="actionButtonText && addToMyPlans">
                    {{actionButtonText}}
            </finder-button>
            <finder-button
                href="{{aagData.customCtaButton.href}}"
                class="action-btn"
                theme="primary"
                *ngIf="aagData.customCtaButton?.title && aagData.customCtaButton?.href">
                {{aagData.customCtaButton.title}}
            </finder-button>
            <finder-premier-access [card]="aagData"></finder-premier-access>
        </div>
    </div>
    <finder-page-message *ngIf="aagData?.pageMessage" [backgroundColor]="aagData?.pageMessage.backgroundColor">
        <span class="dynamic-html" [innerHTML]="aagData?.pageMessage.message | safeHtml"></span>
    </finder-page-message>
</div>
